import React from 'react';
import styled from 'styled-components';

interface LayoutProps {
  className: string;
  css: string;
  children: any;
}

const MainContainer = styled.div`
  ${props => props.css}
`;

const Container = styled.section`
  ${props => props.css}
`;

const MainLayout = ({ className, css, children }: LayoutProps) => {
  return (
    <MainContainer className={className} css={css}>
      {children}
    </MainContainer>
  );
};

const Layout = ({ className, css, children }: LayoutProps) => {
  return (
    <Container className={className} css={css}>
      {children}
    </Container>
  );
};
 

export { MainLayout, Layout };
